import { transportTypeFilterOptionsSelector } from '@/scopes/prices/components/selectors'
import { FlightSelectorNew } from '@/scopes/prices/components/TransportSelector/FlightSelector'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'

export function TransportSelectorNew() {
  const { selectedValue } = usePricesSelector(transportTypeFilterOptionsSelector)

  if (!selectedValue) {
    return null
  }
  // if (selectedValue === 'Bus') {
  //   return <BusSelector />
  // }
  if (selectedValue === 'Flight') {
    return <FlightSelectorNew />
  }
  if (selectedValue === 'SelfDrive') {
    return null
  }
}
